import { Link } from "react-router-dom";
import * as LuIcon from "react-icons/lu";

export default function NotFound() {
  return (
    <>
      <div
        className="d-flex justify-content-center align-items-center flex-column"
        style={{ height: "calc(100vh - 48px)", width: "calc(100% - 240px)", marginLeft: "240px" }}
      >
        <LuIcon.LuConstruction className="system-empty"/>
        <p className="text-center text-secondary">Error 404... Página no encontrada.</p>
        <Link to="/">Volver al inicio</Link>
      </div>
    </>
  );
}
